import type { Reference } from '@platform/entities/entity.class';
import { ConnectDao, Entity } from '@platform/entities/entity.class';
import { Column, Table } from '@platform/shared/rpc/entity-decorators';
import { DataType } from '@platform/shared/rpc/types';
import { FormField } from '@platform/shared/components/auto-form-dialog/decorators';
import { EmployeeDao } from '@platform/entities/employee/employee.dao';

@ConnectDao(EmployeeDao)
@Table({ tableName: 'employee', schemaName: 'pusk', comment: 'employee' })
export class EmployeeEntity extends Entity {
    static formQualifier() {
        return () => import('@platform/layouts/employee/form/employee_form.vue');
    }

    static is_aud_when_sys_user_id = true;
    @Column(DataType.UUID, { ref: 'platform.sys_user', comment: 'Пользователь изменивший запись' })
    aud_when_sys_user_id?: Reference;

    @FormField({
        label: 'Организация',
        component: 'MultiOrgsSelect',
        required: true,
        props: {
            withoutAddOrEditBtn: true,
        },
    })
    @Column(DataType.UUID, { ref: 'platform.contragent', comment: 'Контрагент' })
    contragent_id?: Reference;

    @FormField({ label: 'Примечание' })
    @Column(DataType.VARCHAR)
    description?: string;

    @FormField({
        label: 'Подразделение',
        component: 'FieldSelect',
    })
    @Column(DataType.UUID, { ref: 'platform.employee_department', comment: 'Подразделение' })
    employee_department_id?: Reference;

    @Column(DataType.VARCHAR, { comment: 'Табельный номер' })
    employee_number?: string;

    @FormField({
        label: 'Должность',
        component: 'FieldSelect',
    })
    @Column(DataType.UUID, { ref: 'pusk.employee_post', comment: 'Должность' })
    employee_post_id?: Reference;

    @FormField({ label: 'Включен в табель', component: 'CheckBox' })
    @Column(DataType.BOOLEAN)
    include_in_time_sheet?: boolean;

    @FormField({ label: 'Основная', component: 'CheckBox' })
    @Column(DataType.BOOLEAN)
    main?: boolean;

    @FormField({ label: 'Доступ ко всем проектам', component: 'CheckBox' })
    @Column(DataType.BOOLEAN)
    is_project_all?: boolean;

    @Column(DataType.VARCHAR, { comment: 'Наименование' })
    name?: string | null;

    @FormField({ label: 'Окончание работы', component: 'DatePopup' })
    @Column(DataType.DATE)
    period_end?: DateStr | null;

    @FormField({ label: 'Начало работы', component: 'DatePopup' })
    @Column(DataType.DATE)
    period_start?: DateStr | number | null;

    @FormField({
        label: 'ФИО',
        required: true,
        component: 'FieldSelect',
    })
    @Column(DataType.UUID, { ref: 'pusk.person', comment: 'ФИО' })
    person_id?: Reference;

    @FormField({
        label: 'Проект',
        component: 'FieldSelect',
    })
    @Column(DataType.UUID, { ref: 'platform.project', comment: 'Проект' })
    project_id?: Reference;

    project_list?: any[];

    isMultipleEmployee?: boolean;

    multipleEmployeeName?: string;
}
